import { render } from "./App.vue?vue&type=template&id=67d7a5b1"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=67d7a5b1&lang=css"

import exportComponent from "D:\\XGprogect\\海尔会员\\haierhuiyuan-phone\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__